import { observer } from 'mobx-react';
import { FC } from 'react';
import kioskEditStore from '../../store/kioskEditStore';
import { localeStore } from '~/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text from '~/view/components/Text/Text';

const KioskTerminalId: FC = observer((): JSX.Element => {
  const handleTerminalIdChange = (value: string | undefined) => {
    kioskEditStore.changeEditableKiosk({ terminalId: value });
  };

  return (
    <div className="kiosk__field">
      <Text type="order-field" text="terminal_id" className="kiosk__field-title" />

      <Input
        type="number"
        value={kioskEditStore.editableKiosk.terminalId}
        onChangeValue={handleTerminalIdChange}
        maxLength={16}
        placeholder={localeStore.t('Value')}
      />
    </div>
  );
});

export default KioskTerminalId;
